import styled from 'styled-components';
import { theme } from '@jadwalh/ui';

export const CheckboxWrapper = styled.div`
  label {
    display: flex;
    gap: ${theme.space_size};
    align-items: center !important;

    p {
      margin: 0 !important;
      font-size: 14px !important;
    }

    font-weight: 600;
  }
  .labelTitle {
    font-size: 13px;
    color: #303030;
  }
  .mantine-Checkbox-body {
    align-items: center;
    gap: 12px;
    .mantine-Checkbox-inner {
      width: 16px;
      height: 16px;
    }
  }

  input {
    font-weight: 600;
    border-radius: 4px !important;
    min-width: 16px;
    width: 16px;
    height: 16px;
    border: 1px solid ${theme.colours.newOutline} !important;
    cursor: pointer;
    appearance: none; /* Reset default appearance */
    -webkit-appearance: none;
    -moz-appearance: none;

    &:checked {
      background-color: ${theme.colours.blackText} !important;
      border-color: ${theme.colours.blackText} !important;
    }

    &:checked::after {
      content: '\\2713';
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${theme.colours.blackText} !important;
      border-radius: 4px !important;
      width: 16px;
      height: 16px;
      border: 1px solid ${theme.colours.blackText} !important;
      position: relative;
      right: -1px;
      font-size: 8px;
    }
  }
`;
